module.exports = __webpack_public_path__ + "static/noblet-32246fb8823359fb5a6e84fb0d69dddd.jpg";